/*
 * Util function to point scroll to the specified selector element to p tag
 */
export default function scrollToPoint(point, selector) {
  const selectorElem = selector || '.exclusions-content sup';
  const exclusionElems = document.querySelectorAll(selectorElem);
  exclusionElems.forEach((exclusionElem) => {
    if (exclusionElem.textContent.trim() === point) {
      const elemPara = exclusionElem.closest('p');
      if (elemPara) {
        elemPara.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  });
}
/*
 * Util function to handle click on the component from where to scroll to the point
 */
export function handleClickToPointScroll(event, emit) {
  const { target } = event;
  if (target.tagName === 'SUP') {
    const point = target.textContent.trim();
    emit('scrollToExclusionDetails', point);
  }
}
